import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getEstatesByGroupID,
    SaveNetOutturnData,
    GetNetOutturnData,
    GetNetOutturnDataById,
    UpdateNetOutturnData
};

async function getEstatesByGroupID(id) {
    let estateArray = [];
    const response = await CommonGet('/api/NetOutturn/GetAllEstateByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return estateArray;
}

async function SaveNetOutturnData(saveData) {
    const response = await CommonPost('/api/NetOutturn/SaveNetOutturnData', null, saveData); // Ensure correct route
    return response;
}

async function GetNetOutturnData(model) {
    const response = await CommonPost('/api/NetOutturn/GetNetOutturnData', null, model);
    return response;
}

async function GetNetOutturnDataById(netOutturnID) {
    const response = await CommonGet('/api/NetOutturn/GetNetOutturnDataById', 'netOutturnID=' + netOutturnID);
    return response;
}

async function UpdateNetOutturnData(saveData) {
    const response = await CommonPost('/api/NetOutturn/UpdateNetOutturnData', null, saveData);
    return response;
}